export default "__VITE_ASSET__Cmb$s5gz__"